// extracted by mini-css-extract-plugin
export default {"card":"style_card__PvwVn","card_title":"style_card_title__FwzNM"};